import React from 'react';
import { gql, useQuery } from '@apollo/client';
import ESpotContent from '../ESpotContent/ESpotContent';

const getDynamicContentData = gql`
query DynamicContent(
  $espotId: String!
) {
  content {
    specificESpot(espotId: $espotId) {
      key
      source
      content
    }
  }
}
`;

function HowToMeasurePanel({
  collectionData,
  content,
}) {
  const {
    data, previousData,
  } = useQuery(getDynamicContentData, {
    variables: {
      espotId: `pdp_howtomeasure-${collectionData.howToMeasureContentCode}`,
    },
  });

  const queryData = data || previousData;

  return (
    <>
      <div className="measurement-guide__above-image-text">
        <p>{collectionData.genderTMNT}</p>
      </div>
      {queryData?.content?.specificESpot?.content ? (
        <ESpotContent eSpotData={queryData?.content?.specificESpot} />
      ) : (
        <ESpotContent eSpotData={content?.legacyPDPESpots?.pdp_sizeGuideHowToMeasure} />
      )}
    </>
  );
}

export default HowToMeasurePanel;
